import React from 'react';

// [cite: 46]
function EmptyMessage() {
     return (
        <div className="status-message">
            Aramanızla eşleşen sonuç bulunamadı.
        </div>
    );
}

export default EmptyMessage;